import React, { useState } from 'react';
import { Form, DatePicker, Button, Row, Col, message } from 'antd';
import axiosInstance from '../../services/axiosInstance';
import moment from 'moment';

const SupportTeamReport = ({ handleClose }) => {
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();

    const handleFinish = async (values) => {
        setLoading(true);
        try {
            const from_date = values.dates[0].format('YYYY-MM-DD');
            const to_date = values.dates[1].format('YYYY-MM-DD');

            const response = await axiosInstance.get('/task/v2/support-team-report/download/', {
                params: { from_date, to_date },
                responseType: 'blob',
            });

            if (response.status === 200) {
                const blob = new Blob([response.data], { type: 'text/csv' });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `support_team_report_${from_date}_to_${to_date}.csv`;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
                message.success('Report downloaded successfully');
                handleClose();
            } else {
                message.error('Something went wrong');
            }
        } catch (err) {
            if (
                err?.response?.data instanceof Blob &&
                err?.response?.headers['content-type']?.includes('application/json')
            ) {
                const reader = new FileReader();
                reader.onload = () => {
                    try {
                        const errorJson = JSON.parse(reader.result);
                        message.error(errorJson?.message || errorJson?.detail || 'Something went wrong.');
                    } catch {
                        message.error('An unknown error occurred.');
                    }
                };
                reader.readAsText(err.response.data);
            } else {
                message.error('Failed to download report.');
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <Form form={form} layout="vertical" onFinish={handleFinish}>
            <Row style={{ width: '100%' }}>
                <Col span={24}>
                    <Form.Item
                        label="Select Date Range"
                        name="dates"
                        rules={[{ required: true, message: 'Please select date range' }]}
                    >
                        <DatePicker.RangePicker style={{ width: '100%' }} />
                    </Form.Item>
                </Col>
            </Row>
            <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
                <Button type="primary" htmlType="submit" loading={loading}>
                    Download CSV
                </Button>
            </div>
        </Form>
    );
};

export default SupportTeamReport;
